import { Button, Select, Space } from "antd";
import * as appRoutes from "config/routes.config";
import React, { FC, useEffect, useState } from "react";

import s from "./assets/calendar.module.css";
/* import { UserRoles } from "common/enums"; */
import AppResult from "components/appResults";
/* import Breadcrumbs from "components/breadcrumbs"; */
import SessionsCalendarGridView from "components/classroomComponents/SessionsCalendarGridView/SessionsCalendarGridView";
import { CourseViewType } from "components/classroomComponents/types";
import HelpPopover from "components/help";
import AppButton from "components/libs/button";
import H1 from "components/libs/title";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useGetOrganismRoomsQuery, useGetRoomsQuery } from "store/services/teacher/classes.services";
import CalendarPicture from "../../../assets/images/app/calendar_icon.svg";
import AlbertImage from "../../../assets/images/app/levieuxalbert.svg";
import AppScreen from "../ScreenWithSidebar";
import CalendarOfReservationTeacher from "./c";
import DrawerHistorique from "./components";

const { Option } = Select;

const AppCalendar: FC = () => {

  const auth = useSelector((state) => state.auth);
  const { user } = useSelector((state) => state.auth);
  const { userHavingCalendar, userTeachingOrganismClass } = useSelector((state) => state.app);
  const [openDrawerHistorique, setOpenDrawerHistorique] = useState<boolean>(false);

  const { data: rooms, isLoading, isError, refetch } = useGetRoomsQuery(user?._id);
  const { data: organismRooms, isLoading: loadingOrganismRooms, refetch: refetchOrganismRooms } = useGetOrganismRoomsQuery(user?._id);

  const navigate = useNavigate();

  const [courseView, setCourseView] = useState<CourseViewType>('list');
  const [roomsData, setRoomsData] = useState<any>();
  const [calendarData, setCalendarData] = useState<any>();
  const [filter, setFilter] = useState<any>();
  const [filteredData, setFilteredData] = useState<any[]>([]);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1050);
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 1050);
  };
  window.addEventListener('resize', handleResize);

  useEffect(() => {
    if (calendarData) {
      setFilteredData(calendarData);
    }
  }, [calendarData]);

  useEffect(() => {
    if (isLoading || loadingOrganismRooms) return;

    const merged = [...rooms.data, ...organismRooms.data];

    const unique = merged.filter(
      (room, index, self) =>
        index === self.findIndex((r) => r._id === room._id)
    );

    setRoomsData(unique);
  }, [rooms?.data, organismRooms?.data]);

  const handleFiltering = (value: string) => {
    setFilter(value);

    if (!value) {
      setFilteredData(calendarData);
      return;
    }

    let filtered = calendarData;

    if (value === 'all') {
      setFilteredData(calendarData);
    }
    else if (value === 'particular') {
      filtered = calendarData.filter(
        (session: any) =>
          session.classeId &&
          session.classeId === "" || session.classeId === undefined || session.classeId === null
      );

      setFilteredData(filtered);
    }
    else {
      filtered = calendarData.filter(
        (session: any) =>
          session.classeId &&
          session.classeId === value
      );

      setFilteredData(filtered);
    }
  };

  //!RETURN
  return (
    <React.Fragment>
      {/* <div style={{ marginTop: isMobile && auth.user?.roles?.includes(UserRoles.TEACHER) ? (!userHavingCalendar || userTeachingOrganismClass) ? "130px" : "70px" : "0px" }}> */}
      {/* {!isMobile && <Breadcrumbs isCalendar={true} />} */}
      {user?.isActive && user?.step === "completed" ? <div style={{ marginTop: "0em", padding: "20px" }}>
        {isMobile ? <div className={s.headerBox}>
          <div className={s.headerBoxTitleFull}>
            <div className={s.titleBox}>
              <div className={s.titlePictureBox}>
                <img src={CalendarPicture} height={isMobile ? 20 : 35}></img>
              </div>
              Planning des cours
            </div>

            <div className={s.buttonBox}>
              <Button className={s.newButton} onClick={() => setOpenDrawerHistorique(true)}>
                Mon historique
              </Button>
              <div style={{ marginLeft: "10px", marginTop: "5px" }}>
                <HelpPopover id={"planning_des_cours_mon_historique"} />
              </div>
            </div>
          </div>

          <div className={s.headerBoxTitle} style={{ marginTop: "15px" }}>
            <Space style={{ marginLeft: "10px" }}>
              {courseView === 'calendar' && <Button
                type={'default'}
                onClick={() => setCourseView('list')}
                style={{ borderRadius: '20px' }}
              >
                Vue par liste
              </Button>}
              {courseView !== 'calendar' && <Button
                type={'default'}
                onClick={() => setCourseView('calendar')}
                style={{ borderRadius: '20px' }}
              >
                Vue calendrier
              </Button>}
            </Space>

            <Select
              value={filter}
              onChange={(value) => handleFiltering(value)}
              className="select-filter"
              placeholder={<span style={{ fontSize: "12px" }}>Filtrer</span>}
            >
              {roomsData?.map((room: any, index: number) => (
                <Option key={index} value={room?._id}>{room?.title}</Option>
              ))}
              <Option value="particular">Mes cours particuliers</Option>
              <Option value="all">Toutes les réservations</Option>
            </Select>
          </div>
        </div> : <div className={s.headerBox}>
          <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "flex-start", gap: "10px" }}>
            {/* <div className={s.titleBox}>
                  <div className={s.titlePictureBox}>
                    <img src={CalendarPicture} height={isMobile ? 20 : 35}></img>
                  </div>
                  Planning des cours
                </div> */}

            <Space style={{ marginLeft: "0px" }}>
              {courseView === 'calendar' && <Button
                type={'default'}
                onClick={() => setCourseView('list')}
                style={{ borderRadius: '20px' }}
              >
                Vue par liste
              </Button>}
              {courseView !== 'calendar' && <Button
                type={'default'}
                onClick={() => setCourseView('calendar')}
                style={{ borderRadius: '20px' }}
              >
                Vue calendrier
              </Button>}
            </Space>

            <Select
              value={filter}
              onChange={(value) => handleFiltering(value)}
              className="select-filter"
              placeholder={<span style={{ fontSize: "12px" }}>Filtrer</span>}
            >
              {roomsData?.map((room: any, index: number) => (
                <Option key={index} value={room?._id}>{room?.title}</Option>
              ))}
              <Option value="particular">Mes cours particuliers</Option>
              <Option value="all">Toutes les réservations</Option>
            </Select>
          </div>

          <div className={s.buttonBox}>
            <Button className={s.newButton} onClick={() => setOpenDrawerHistorique(true)}>
              Mon historique
            </Button>
            <div style={{ marginLeft: "10px", marginTop: "5px" }}>
              <HelpPopover id={"planning_des_cours_mon_historique"} />
            </div>
          </div>
        </div>}

        {courseView === 'list' ? <div className={s.calendrier}>
          <div className={s.calendar__content}>
            <CalendarOfReservationTeacher setCalendarData={setCalendarData} filter={filter} />
          </div>
        </div> : filteredData?.length > 0 ? <SessionsCalendarGridView
          sessions={filteredData}
          showFilter={false}
          isTeacherCalendar={true}
        /> : <AppResult status={"info"} title={"Aucune séance"}></AppResult>}
      </div> : <AppScreen className={s.dashboard}>
        <H1 className={s.title}>Bienvenue {auth?.user?.firstname}</H1>
        <div className={s.dashboardUserBox}>
          <img src={AlbertImage} width={240} height={240} style={{ marginTop: "20px", marginBottom: "10px" }}></img>
          <p className={s.dashboardUserMessage} style={{ fontFamily: "CartoonFont" }}>Oups, tu n’as pas encore accès à cette fonctionnalité!<br /> Patience... ton compte est en cours de validation. </p>
          {user?.step !== "completed" && <AppButton onClick={() => navigate(appRoutes.COMPLETE_PROFILE)}>Completer mon profil</AppButton>}
        </div>
      </AppScreen>}

      <DrawerHistorique
        open={openDrawerHistorique}
        setOpen={setOpenDrawerHistorique}
      />
      {/* </div> */}
    </React.Fragment>
  );
};

export default AppCalendar;
